import {DiscountModel, ProductModel} from "../Models/ProductModel";
import {OrderProductModel} from "../Models/OrderModel";
import {useGetTva} from "./useGetTva";
import {useGetReductionFromQuantity} from "./useGetReductionFromQuantity";

export const useCreateOrderWithQuantityDiscount = (): (product: ProductModel, discount: DiscountModel, quantitee: number, otherOrderProducts: OrderProductModel[]) => OrderProductModel => {
    const getTva = useGetTva()
    const [getTotalMinusReduction, getReduction] = useGetReductionFromQuantity()


    return (product: ProductModel, discount: DiscountModel, quantitee: number, otherOrderProducts: OrderProductModel[]): OrderProductModel => {
        const unitTva = getTva(product.priceTTC, product.product.tva.rate)
        const unitPriceHT = product.priceTTC - unitTva
        return {
            name: product.product.name,
            quantity: quantitee,
            unitPriceHT: unitPriceHT + product.depositPriceTTC,
            unitPriceTTC: product.priceTTC + product.depositPriceTTC,
            unitDepositPriceTTC: product.depositPriceTTC,
            tvaRate: product.product.tva.rate,
            discountName: discount.name,
            discountType: 'quantity',
            discountModel: discount,
            discount: getReduction(product.priceTTC * quantitee, product.priceTTC, quantitee, discount, otherOrderProducts),
            totalPriceHT: +(getTotalMinusReduction(unitPriceHT * quantitee, product.priceTTC, quantitee, discount, otherOrderProducts).toFixed(5)) + (product.depositPriceTTC * quantitee),
            totalPriceTTC: +(getTotalMinusReduction(product.priceTTC * quantitee, product.priceTTC, quantitee, discount, otherOrderProducts) + (product.depositPriceTTC * quantitee)).toFixed(2),
            totalDepositPriceTTC: product.depositPriceTTC * quantitee,
            totalTva: +(getTotalMinusReduction(unitTva * quantitee, product.priceTTC, quantitee, discount, otherOrderProducts)).toFixed(2),
            tvaCode: product.product.tva.id,
            product: {
                id: product.product.id,
                image: product.product.image,
                categories: product.product.productCategories,
            }
        }
    }
}
